<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <div class="horizontal-center">
        <mat-label>{{data.detail}}</mat-label>
        <div class="flex-container-center">
            <button mat-icon-button color="accent" (click)="countTap(-1)">
                <mat-icon>remove</mat-icon>
            </button>
            <div class="stepper-text-container"><span>{{data.count}}</span></div>
            <button mat-icon-button color="accent" (click)="countTap(1)">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="">{{data.cancel}}</button>
  <button mat-button [mat-dialog-close]="data.count" cdkFocusInitial>{{data.accept}}</button>
</div>